module.exports = __webpack_public_path__ + "static/media/bedroom.1200817a.svg";